import { useApplicationUiStore } from '@src/shared/store/ui-store/application-ui-store';
import React, { FC, ReactNode, useEffect, useRef } from 'react';
import { Options, Util } from 'snacks-design-system';

export interface IPIESegmentedControlOption {
  label: string;
  value: string;
}

export enum PIESegmentedControlSizes {
  SMALL = 'small',
  MEDIUM = 'medium',
}

export interface IPIESegmentedAriaProperty {
  label: string;
  labelledby: string;
}

interface IPIESegmentedControl {
  options: Array<IPIESegmentedControlOption>;
  name: string;
  value?: string;
  disabled?: Boolean;
  label?: ReactNode;
  size?: PIESegmentedControlSizes;
  showLabelContainer?: Boolean;
  modFluid?: Boolean;
  modToggle?: Boolean;
  aria?: IPIESegmentedAriaProperty;
  onChange?: (value: any) => void;
  qaSelector?: string;
}

export const PIESegmentedControl: FC<IPIESegmentedControl> = (props) => {
  const segmentedRef = useRef<HTMLDivElement>(null);
  const { setAppDomElementClientHeightRef } = useApplicationUiStore();

  useEffect(() => {
    if (segmentedRef.current) {
      setAppDomElementClientHeightRef({
        domElementOffsetB: segmentedRef.current.clientHeight,
      });
    }
  }, []);
  return (
    <Util ref={segmentedRef} modRelative={true}>
      <Options {...props} />
    </Util>
  );
};

export default PIESegmentedControl;
